import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import * as XLSX from 'xlsx';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

const InvoiceReport = () => {

    const location = useLocation();
    const [getData, setGetData] = useState([]);
    const [date, setDate] = useState('');

    const formatDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
		return formattedDate;
	};

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
		return formattedDate;
	};

    const changeDate = async (e) =>{
		const date = e.target.value;
		const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
		setDate(formattedDate);

		try {
			const response = await axios.post('https://api.trucoo.in/chellan/chellan/', {date: formattedDate}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				//const filterData = response.data.data.filter(datas => datas.status === 'Placed');
				setGetData(response.data.data);
				setDate(response.data.date);
			}else{
				setGetData([]);
				setDate(response.data.date);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}

	};

    // const currentDate = new Date();
    // const currentYear = currentDate.getFullYear();
    
    // const months = [
    //     { label: 'January', value: 1 },
    //     { label: 'February', value: 2 },
    //     { label: 'March', value: 3 },
    //     { label: 'April', value: 4 },
    //     { label: 'May', value: 5 },
    //     { label: 'June', value: 6 },
    //     { label: 'July', value: 7 },
    //     { label: 'August', value: 8 },
    //     { label: 'September', value: 9 },
    //     { label: 'October', value: 10 },
    //     { label: 'November', value: 11 },
    //     { label: 'December', value: 12 },
    // ];

    
    const getdata = async () => {
            try {
                const response = await axios.post('https://api.trucoo.in/chellan/chellan/', {}, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });
                console.log(response.data);
                if (response.data.status === 'success') {
                    setGetData(response.data.data);
                    setDate(response.data.date);
                }else{
                    setGetData([]);
                    setDate(response.data.date);
                }
            } catch (error) {
                console.error("Error:", error.response || error.message);
            }
    };
    //console.log(date);
    useEffect(() => {
        getdata();
    }, []);

    function getFiscalYearLabel(date = new Date()) {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };


    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, 'Monthly_Invoice_Report.xlsx');
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Chellan</h4>
                                <p className="mb-0 box-subtitle">Chellan Report</p>
                                <input type="date" class="form-control" value={formatDate(date)} onChange={(e)=>changeDate(e)} style={{width: '200px', float: 'right', marginTop: '-20px'}} />
                            </div>
                            <div className="box-body">
                                <div className="row"> 
                                    <div className="col-lg-3 mb-4">
                                        {/* <select 
                                            value={selectedMonth} 
                                            onChange={(e) => setSelectedMonth(Number(e.target.value))} 
                                            className="border p-2"
                                        >
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </select> */}
                                        {/* <input 
                                            type="date" 
                                            value={formatViewDate(date)} 
                                            onChange={(e) => changeDate(e)} 
                                            className="border p-2" 
                                        /> */}
                                    </div>
                                    <div className="col-lg-3 mb-4">
                                       
                                    </div>
                                    <div className="col-lg-6 mb-4" align="right">
                                        <button onClick={downloadExcel} className="btn btn-primary"> Download Excel </button>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="table-responsive">
                                            {getData?.length > 0 ?
                                                <table id="printableArea" className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100 fs-12">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Invoice ID</th>
                                                            <th>Date</th>
                                                            <th>Dealer</th>
                                                            <th>Discount</th>
                                                            <th>GST</th>
                                                            <th>Items</th>
                                                            <th>Payment Status</th>
                                                            <th>Total Payment</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {getData.map((order, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>DC/{order?.invoiceId}/{getFiscalYearLabel(new Date(order?.date))}</td>
                                                                <td>{formatViewDate(order.date)}</td>
                                                                <td>{order.dealerData.dealer} - <small>{order.dealerData.name}</small></td>
                                                                <td>{parseFloat(order.discount).toFixed(2)}</td>
                                                                <td>{parseFloat(order.gst).toFixed(2)}</td>
                                                                <td>{order.items}</td>
                                                                <td>{order.paymentStatus}</td>
                                                                <td>{(parseFloat(order.totalPayment) - parseFloat(order.discount)).toFixed(2)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            :
                                            <p className="text-danger" align="center"> No Data Available</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default InvoiceReport;